import { useEffect, useState } from 'react'

import { motion } from 'framer-motion'

import { HomeStory } from './Home/HomeStory'
import { Spec } from './Home/Spec'
import { Hero } from './Home/Hero'
import { HomeChar } from './Home/HomeChar'
import { HomeSystem } from './Home/HomeSystem'
// import { Trailers } from './Home/Trailers'
import { Topics } from './Topics'
import ReactPlayer from 'react-player'
import { FullScreenModal } from '../utility/FullScreenModal'

export const Home = ({ mediaItem }) => {
    const [isPlaying, setIsPlaying] = useState(null)
    const [showButton, setShowButton] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', url: '', index: 0 })

    const handleOpenModal = (contentType, category, url, index, maxIndex) => {
        setModalContent({ contentType, category, url, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 300) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        })
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    useEffect(() => {
        const onscroll = () => {
            const scrolledTo = window.scrollY + window.innerHeight
            const isNearBottom = document.body.scrollHeight - scrolledTo <= 300
            if (isNearBottom) setShowButton(false)
        }
        window.addEventListener('scroll', onscroll)
        return () => {
            window.removeEventListener('scroll', onscroll)
        }
    }, [])

    return (
        <>
            <div className='bg-island'>
                <Hero />
                {/* <Topics /> */}
                <div className='max-w-[1200px] mx-auto'>
                    <div className='px-4'>
                        <div className='my-28 max-w-[1200px] mx-auto'>
                            <div className='flex flex-wrap justify-between '>
                                {/* <Trailers /> */}{' '}
                                <div className='w-full lg:w-[48%] mx-auto text-center'>
                                    <div className='video-thumb'>
                                        {' '}
                                        <img
                                            onClick={() => {
                                                handleOpenModal(
                                                    'video',
                                                    'home',
                                                    'https://youtu.be/fBkkWDkbrHA?feature=shared',
                                                    1
                                                )
                                                console.log()
                                            }}
                                            className='ss-thumb'
                                            alt='gameflow button'
                                            src={`${process.env.PUBLIC_URL}/images/steam-launch-trailer-thum.webp`}
                                        />{' '}
                                    </div>{' '}
                                    <span className='relative newicon-nav inline-block'>
                                        <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lmd font-pop my-4 '>
                                            Bande-annonce de lancement sur Steam
                                        </h1>{' '}
                                    </span>
                                </div>{' '}
                                <div className='w-full lg:w-[48%] mx-auto text-center'>
                                    <div className='video-thumb '>
                                        {' '}
                                        <img
                                            onClick={() => {
                                                handleOpenModal('video', 'home', 'https://youtu.be/gdyTrNa_PFg', 1)
                                                console.log()
                                            }}
                                            className='ss-thumb'
                                            alt='gameflow button'
                                            src={`${process.env.PUBLIC_URL}/images/PB2_SteamRDA.webp`}
                                        />{' '}
                                    </div>{' '}
                                    <span className='relative'>
                                        <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lmd font-pop my-4 '>
                                            Vidéo de l'annonce de la date de sortie sur Steam
                                        </h1>{' '}
                                    </span>
                                </div>
                                <div className='w-full lg:w-[48%] mx-auto text-center mt-12'>
                                    <div className='video-thumb '>
                                        {' '}
                                        <img
                                            onClick={() => {
                                                handleOpenModal('video', 'home', 'https://youtu.be/BxPMGEWbX1I', 1)
                                                console.log()
                                            }}
                                            className='ss-thumb'
                                            alt='gameflow button'
                                            src={`${process.env.PUBLIC_URL}/images/PB2_PV4.webp`}
                                        />{' '}
                                    </div>{' '}
                                    <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lmd font-pop my-4 '>
                                        Bande-annonce de Lancement
                                    </h1>{' '}
                                </div>
                                {/* <div >
                                    {' '}
                                    <div className='video-thumb'>
                                        <img
                                            onClick={() => {
                                                handleOpenModal(
                                                    'video',
                                                    'home',
                                                    'https://www.youtube.com/watch?v=nuR3rUklk_I',
                                                    1
                                                )
                                                console.log()
                                            }}
                                            className='ss-thumb video-thumb'
                                            alt='gameflow button'
                                            src={`${process.env.PUBLIC_URL}/images/NinDi.webp`}
                                        />{' '}
                                    </div>{' '}
                                    <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lg font-pop my-4'>
                                        Nintendo Direct 2024.6.18
                                    </h1>{' '}
                                </div>{' '} */}
                            </div>{' '}
                        </div>
                    </div>
                    <HomeStory />
                    <HomeChar />
                    <HomeSystem />
                    <Spec />
                </div>
                {showButton && (
                    <motion.button
                        initial={{
                            opacity: 0,
                            transition: {
                                duration: 1,
                                ease: 'easeInOut',
                            },
                        }}
                        whileInView={{
                            opacity: 1,
                            transition: {
                                duration: 1,
                                ease: 'easeInOut',
                            },
                        }}
                        viewport={{ once: false }}
                        onClick={scrollToTop}
                        className='fixed bottom-0 right-1 md:right-[8px] cursor-pointer z-20 duration-300'
                    >
                        <img
                            className='w-2/5 md:w-4/5 ml-auto'
                            src={`${process.env.PUBLIC_URL}/images/top.png`}
                            alt='scroll to top'
                        />
                    </motion.button>
                )}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={1}
                />
            </div>
        </>
    )
}
